import React from 'react'
import './style.css'

const Footer = (props) => {
  return (
    <footer>
      <div className='container foot navbar-expand-lg'>
        <div className='data-row'>
          <div className='footer-col col-6 col-md-3'>
            <h4>Footer</h4>
            <ul>
              <li><a href="">Item1</a></li>
              <li><a href="">Item2</a></li>
              <li><a href="">Item3</a></li>
              <li><a href="">Item4</a></li>
            </ul>
          </div>

          <div className='footer-col col-6 col-md-3'>
            <h4>Footer</h4>
            <ul>
              <li><a href="">Item1</a></li>
              <li><a href="">Item2</a></li>
              <li><a href="">Item3</a></li>
              <li><a href="">Item4</a></li>
            </ul>
          </div>

          <div className='footer-col col-6 col-md-3'>
            <h4>Footer</h4>
            <ul>
              <li><a href="">Item1</a></li>
              <li><a href="">Item2</a></li>
              <li><a href="">Item3</a></li>
              <li><a href="">Item4</a></li>
            </ul>
          </div>

          <div className='footer-col col-6 col-md-3'>
            <h4>Footer</h4>
            <ul>
              <li><a href="">Item1</a></li>
              <li><a href="">Item2</a></li>
              <li><a href="">Item3</a></li>
              <li><a href="">Item4</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container">
        <img src={require('./loading.png')} onClick={() => {props.handleLoad()}} alt="icon" className="bottom-right img_hover"/>
      </div>
    </footer>
  )
}

export default Footer
